import twopir from "../../assets/company/twopir.png";
import gidr from "../../assets/company/gidr.png";
import nirma from "../../assets/company/nirma.png";
import Salesforce from "../../assets/company/Salesforce_Logo.png";
import neodocto from "../../assets/company/neodocto.png";

const experiences = [
  {
    title: "Associate Software Developer",
    company_name: "Twopir Consulting Pvt Ltd",
    icon: twopir,
    iconBg: "#efefef",
    date: "October 2024 - Present",
    class: "mt-1",
    points: [
      "Built AI-powered CRM lead qualification systems for multiple enterprise clients, automating 100% of qualification and saving 30+ hours/week in sales operations.",
      "Developed custom Node.js and Express backend services integrated with OpenAI Assistants API, HubSpot, and Salesforce, enabling 95% reduction in manual CRM entry.",
      "Designed and deployed production-grade n8n and Zapier workflows managing 100k+ monthly executions with structured logging and error alerting.",
      "Constructed REST APIs and integrated Google Maps Geolocation & Calendly scheduling for instant, automated sales-call routing (40% improvement in response time).",
      "Delivered 20+ enterprise integration implementations, mentoring team members on secure JWT/cookie-based session state and Git flow policies."
    ],
  },
  {
    title: "IT Head & Full-Stack Developer",
    company_name: "Gujarat Institute of Development Research",
    icon: gidr,
    iconBg: "#E6DEDD",
    date: "Dec 2023 - Aug 2024",
    points: [
      "Led IT infrastructure operations, administering secure servers and designing full-stack analytics dashboards (ReactJS, NodeJS, MongoDB, ExpressJS).",
      "Optimized database lookup operations and compound index definitions, leading to a 35% performance speedup in large dataset queries.",
      "Engineered automated backup scripts and implemented Firebase authentication workflows for internal web utilities."
    ],
  },
  {
    title: "Salesforce Developer Intern",
    company_name: "Salesforce",
    icon: Salesforce,
    iconBg: "#E6DEDD",
    date: "Nov 2023 - Jan 2024",
    points: [
      "Developed and maintained cloud business applications using Apex Classes, Triggers, Lightning Web Components (LWC), and Declarative Flows.",
      "Built secure REST API integrations between Salesforce and external platforms using OAuth 2.0 protocols and validation rules.",
      "Created SOQL and SOSL search algorithms to index enterprise database fields, accelerating search operations by 50%."
    ],
  },
  {
    title: "Software Developer Intern",
    company_name: "NeoDocto Inc",
    icon: neodocto,
    iconBg: "#E6DEDD",  
    date: "June 2023 - Aug 2023",
    points: [
      "Built responsive, accessible user interfaces using React and Tailwind CSS, reducing initial page render size through dynamic imports.",
      "Collaborated in design sprints, integrating MongoDB database layers and resolving JWT verification vulnerabilities on public routes."
    ],
  },
  {
    title: "B.Tech in Electrical Engineering (Minors in CS)",
    company_name: "Nirma University",
    icon: nirma,
    iconBg: "#E6DEDD",
    date: "Aug 2020 - May 2024",
    class: "p-1",
    points: [
      "Graduated with honors, focusing on core computer science tracks: Data Structures, Algorithms, OOP, Database Systems, and Web Engineering.",
      "Completed GenAI capstones and led research projects applying OpenCV machine learning models to home automation systems."
    ],
  }
];

export { experiences };
